import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';

import { TimePicker } from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {getDayOfWeekPT, roundTime} from '../Common/helpers';
import DayOffModalBox from '../Common/Modals/DayOffModalBox';
import BreakModalBox from '../Common/Modals/BreakModalBox';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

import './style.css';

var moment = require('moment');

class Schedules extends Component {
    constructor(props) {
        super(props);

        this.state = {
            staffId:this.props.props.match.params.id
            ,openModal:false
            ,dayOffOpenModal:false
            ,dayOffId:""
            ,dateStarted:""
            ,dateEnded:""
            ,tableLoading:false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,editable: (this.props.isAdmin || (this.props.loginData.profile.Schedules && this.props.loginData.profile.Schedules.permission === 1))
            ,somethingWasEdited: false
            ,breakOpenModal:false
            ,breakDate:""
            ,fetchStores:null
            ,fetchData:null
            ,loading:false
            ,year:typeof this.props.year !== "undefined" ? this.props.year : moment(new Date()).format('YYYY')
            ,month:typeof this.props.month !== "undefined" ? this.props.month : moment(new Date()).format('MM')
            ,hoursIn: {}
            ,hoursOut: {}
            ,stores: {}
        };
    }

    filledInfields = false;

    componentWillMount() {
        const getTotals = this.props.loginData.AccessLevel ? "&gettotals=1" : "";
        this.setState({tableLoading:true});

        Promise.all([
            fetch(API + "getschedules&getbystaffid=" + this.state.staffId + "&year=" + this.state.year + "&month=" + this.state.month + getTotals)
            ,fetch(API + "getstores")
        ])
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            this.filledInfields = false;
            this.setStateObjs(data[0], this.state.year, this.state.month);
            this.setState({ fetchData: data[0], fetchStores: data[1].data, isActive:1, tableLoading:false });
        });
    }

    fetchData = () => {
        const getTotals = this.props.loginData.AccessLevel ? "&gettotals=1" : "";
        this.setState({tableLoading:true});
        fetch(API + 'getschedules&getbystaffid=' + this.state.staffId + "&year=" + this.state.year + "&month=" + this.state.month + getTotals)
        .then(response => response.json())
        .then(result => {
            if(result === null || result.shortmsg === "NOK"){
                this.props.props.history.push('/Staff/Schedules');
                return;
            }
            this.setState({ fetchData: result, tableLoading:false })
        });
    }

    handleMonthChange = (year, month) => {
        this.filledInfields = false;
        this.setState({tableLoading:true});
        fetch(API + "getschedules&getbystaffid=" + this.state.staffId + "&year=" + year + "&month=" + month)
        .then(response => response.json())
        .then(data => this.setStateObjs(data, year, month));
    }

    handleFieldChange = (e, value) => {this.setState({ [e.target.id]: value, somethingWasEdited:true });}
    handleStoreChange = (el, e) => {
        let newObj = JSON.parse(JSON.stringify(this.state.stores));
        newObj[el] = e.target.value.toString();
        this.setState({stores:newObj});
    }
    handleHoursInChange = (el, e) => {
        let newObj = Object.assign({}, this.state.hoursIn);
        newObj[el] = roundTime(e, moment.duration(5, "minutes"), "round");
        this.setState({hoursIn:newObj});
    }
    handleHoursOutChange = (el, e) => {
        let newObj = Object.assign({}, this.state.hoursOut);
        newObj[el] = roundTime(e, moment.duration(5, "minutes"), "round");
        this.setState({hoursOut:newObj});
    }

    handlePrevMonth = () => {
        let curDate = new Date(this.state.year + "-" + this.state.month)
            , prevMonth = new Date(curDate.setMonth(curDate.getMonth() - 1));

        this.handleMonthChange(moment(prevMonth).format('YYYY'), moment(prevMonth).format('MM'));
    }

    handleNextMonth = () => {
        let curDate = new Date(this.state.year + "-" + this.state.month)
            , nextMonth = new Date(curDate.setMonth(curDate.getMonth() + 1));

        this.handleMonthChange(moment(nextMonth).format('YYYY'), moment(nextMonth).format('MM'));
    }

    handleSearch = (search) => {
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchschedule&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleSave = () => {
        let storesArr = []
            , hoursInArr = []
            , hoursOutArr = [];

        for (var key in this.state.stores) {
            storesArr.push(this.state.stores[key]);
            hoursInArr.push(moment(this.state.hoursIn[key.replace("stores", "hoursIn")]).format("HH:mm:00"));
            hoursOutArr.push(moment(this.state.hoursOut[key.replace("stores", "hoursOut")]).format("HH:mm:00"));
        }

        let DEFAULT_QUERY = "saveschedule&staffid=" + this.state.staffId + "&year=" + this.state.year + "&month=" + this.state.month + "&hoursin=" + hoursInArr.join(",")
                            + "&hoursout=" + hoursOutArr.join(",") + "&stores=" + storesArr.join(",") + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

        this.setState({tableLoading:true});
        fetch(API + DEFAULT_QUERY)
        .then(response => response.json())
        .then(result => this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false }));
    }

    setStateObjs = (fetchData, year, month) => {
        if(!this.filledInfields&&fetchData!==null){
            this.filledInfields = true;
            var data = fetchData.data.days
                , hoursInObj = {}
                , hoursOutObj = {}
                , storesObj = {};

            for(var i=0,n=data.length;i<n;i++){
                hoursInObj["hoursIn_"+data[i].Date] = moment(data[i].Date + " " + data[i].HoursIn);
                hoursOutObj["hoursOut_"+data[i].Date] = moment(data[i].Date + " " + data[i].HoursOut);
                storesObj["stores_"+data[i].Date] = data[i].StoreId;
            }

            this.setState({fetchData: fetchData, year: year, month: month, hoursIn: hoursInObj, hoursOut: hoursOutObj, stores: storesObj, tableLoading:false });
        }
    }

    openDayOffModalBox = (dayOffId, date) => {
        this.setState({dayOffId:dayOffId, dateStarted:date, dateEnded:date, dayOffOpenModal: true });
    }

    openBreakModal = (date) => {
        this.setState({breakDate:date, breakOpenModal: true });
    }

    dayOffCallBack = (result, keepModalOpen) => {
        if(result !== false){
            this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message, openModal: true, loading:false });
        }
        this.setState({ dayOffOpenModal: keepModalOpen});
    }

    breakCallBack = (result, keepModalOpen) => {
        if(result !== false){
            this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message, openModal: true, loading:false });
        }
        this.setState({ breakOpenModal: keepModalOpen});
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.fetchData();
    }

    renderStoresOptions = (e) => {
        const stores = this.state.fetchStores;
        if(stores===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=stores.length;i<n;i++) {
            items.push(<MenuItem value={stores[i].Id} key={stores[i].Id}>
                             {<div><div className="smallColorDiv" style={{backgroundColor: stores[i].Color}}></div> <span>{stores[i].Name + " - " + stores[i].Shortname}</span></div>}
                       </MenuItem>);
        }
        return items;
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { editable } = this.state;

        const schedules = this.state.fetchData!==null ? this.state.fetchData.data.days : []
              , staffName = this.state.fetchData!==null ? this.state.fetchData.data.staff[0].FirstName + " " + this.state.fetchData.data.staff[0].LastName : []
              , optsStores = this.renderStoresOptions()
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , printProps = {pathname:"/PrintStaffSchedule/" + this.state.staffId + "/" + this.state.month + "/" + this.state.year};

        return (
                <div id="staffSchedulePage" className="addEditPage">
                    <div>
                        <div className="pageHeader">
                            <h1><i className="fa fa-user-md"></i> {staffName}
                                { (isAdmin || loginData.profile.Schedules.canPrintSchedule) && 
                                    <span className="float-right printHolder">
                                        <NavLink type="button" className="simpleBtn actionButton success" to={printProps} target="_blank" title={"Imprimir hoário de " + staffName}>Imprimir <i className="fa fa-print fa-2x"></i></NavLink>
                                    </span>
                                }
                            <p className="dateHolder">
                                { (isAdmin || loginData.profile.Schedules.seePast) && 
                                    <Tooltip
                                        title={"Mês Anterior"}
                                        enterDelay={200}>
                                        <button type="button" onClick={this.handlePrevMonth} className="button simpleBtn actionButton mainColor"><i className='fa fa-chevron-left'></i></button>
                                    </Tooltip>
                                }
                                <span className="selectedDate">{this.state.year + "/" + this.state.month}</span>
                                { (isAdmin || loginData.profile.Schedules.seeFuture) && 
                                    <Tooltip
                                        title={"Mês Seguinte"}
                                        enterDelay={200}>
                                        <button type="button" onClick={this.handleNextMonth} className="button simpleBtn actionButton mainColor"><i className='fa fa-chevron-right'></i></button>
                                    </Tooltip>
                                }
                            </p></h1>
                        </div>
                        <Table className={"responsiveTable customTable" + loadingClass}>
                            <TableHead>
                                <TableRow className="tableRow tableHeader">
                                    <TableCell className="tableCell">Dia</TableCell>
                                    <TableCell className="tableCell">Dia da Semana</TableCell>
                                    <TableCell className="tableCell">Entrada</TableCell>
                                    <TableCell className="tableCell">Saída</TableCell>
                                    <TableCell className="tableCell">Clinica</TableCell>
                                    <TableCell className="tableCell">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody ref="tableBody">
                                {schedules.map(schedule => {
                                    let isDayOff = schedule.DayOff==="1" ? "disabledRow" : ""
                                        ,dayOffId = schedule.DayOffId!=="0" ? schedule.DayOffId : "New"
                                        ,validJust = schedule.IsValidJustification==="0" ? "invalidJustification" : "";
                                    return(
                                        <TableRow key={schedule.Day} className={"tableRow " + isDayOff + " " + validJust} ref={"store_" + schedule.Day}>
                                            <TableCell data-title="Dia" className="tableCell">{schedule.Day}</TableCell>
                                            <TableCell data-title="Dia da Semana" className="tableCell">{getDayOfWeekPT(schedule.DayOfWeek)}</TableCell>
                                            <TableCell data-title="Entrada" className="tableCell hoursCell">
                                                <div className="fieldHolder">
                                                    <TimePicker
                                                        fullWidth
                                                        id={"hoursIn_"+schedule.Date}
                                                        name={"hoursIn_"+schedule.Date}
                                                        value={this.state.hoursIn["hoursIn_"+schedule.Date]}
                                                        onChange={this.handleHoursInChange.bind(this, "hoursIn_"+schedule.Date)}
                                                        ampm={false}
                                                        format="HH:mm"
                                                        placeholder="Hora de Entrada"
                                                        label="Hora de Entrada"
                                                        disabled={!editable || schedule.DayOff === "1"}
                                                        InputLabelProps={{shrink: true}}
                                                        inputProps={{step: 300}}
                                                    />
                                                </div>
                                            </TableCell>
                                            <TableCell data-title="Saída" className="tableCell hoursCell">
                                                <div className="fieldHolder">
                                                    <TimePicker
                                                        fullWidth
                                                        id={"hoursOut_"+schedule.Date}
                                                        name={"hoursOut_"+schedule.Date}
                                                        type="time"
                                                        value={this.state.hoursOut["hoursOut_"+schedule.Date]}
                                                        onChange={this.handleHoursOutChange.bind(this, "hoursOut_"+schedule.Date)}
                                                        placeholder="Hora de Saída"
                                                        label="Hora de Saída"
                                                        disabled={!editable || schedule.DayOff === "1"}
                                                        ampm={false}
                                                        format="HH:mm"
                                                        InputLabelProps={{shrink: true}}
                                                        inputProps={{step: 300}} />
                                                </div>
                                            </TableCell>
                                            <TableCell data-title="Clínica" className="tableCell storeCell">
                                                <div className="fieldHolder required selectField">
                                                    <FormControl fullWidth>
                                                        <InputLabel htmlFor={"stores_"+schedule.Date}>Escolha uma clínica</InputLabel>
                                                        <Select id={"stores_"+schedule.Date}
                                                                name={"stores_"+schedule.Date}
                                                                className="storePicker"
                                                                value={this.state.stores["stores_"+schedule.Date]}
                                                                onChange={this.handleStoreChange.bind(this, "stores_"+schedule.Date)}
                                                                disabled={!editable || schedule.DayOff === "1"}
                                                                data-empty-error-message="Este campo não pode estar vazio">
                                                              {optsStores}
                                                         </Select>
                                                     </FormControl>
                                                </div>
                                            </TableCell>
                                            <TableCell data-title="Ações" className="tableCell actions" data-row-id={schedule.Id}>
                                                {schedule.Id &&
                                                    <span>
                                                        { (isAdmin || loginData.profile.Schedules.handleBreaks) && 
                                                            <Tooltip
                                                                title={"Gerir pausas"}
                                                                enterDelay={200}>
                                                                <span><button type="button" className="simpleBtn actionButton warning" disabled={schedule.DayOff === "1"} onClick={() => this.openBreakModal(schedule.Date)}><i className="fa fa-coffee"></i></button></span>
                                                            </Tooltip>
                                                        }
                                                        { (isAdmin || loginData.profile.Schedules.handleHolidays) && 
                                                            <Tooltip
                                                                title={"Gerir folgas"}
                                                                enterDelay={200}>
                                                                <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.openDayOffModalBox(dayOffId, schedule.Date)}><i className="fa fa-ban"></i></button></span>
                                                            </Tooltip>
                                                        }
                                                    </span>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
    				</div>
                    {(isAdmin || loginData.profile.Schedules.seeTotals) && this.state.fetchData!==null &&
                        <div className={"row statsHolder" + loadingClass}>
                            <div className="col-6 col-md-2">
                                { (isAdmin || loginData.profile.Schedules.seePast) && 
                                    <Tooltip
                                        title={"Mês Anterior"}
                                        enterDelay={200}>
                                        <button type="button" onClick={this.handlePrevMonth} className="button simpleBtn actionButton mainColor"><i className='fa fa-chevron-left'></i></button>
                                    </Tooltip>
                                }
                            </div>
                            <div className="col-6 col-md-2 text-right hidden-md-up">
                                { (isAdmin || loginData.profile.Schedules.seeFuture) && 
                                    <Tooltip
                                        title={"Mês Seguinte"}
                                        enterDelay={200}>
                                        <button type="button" onClick={this.handleNextMonth} className="button simpleBtn actionButton mainColor"><i className='fa fa-chevron-right'></i></button>
                                    </Tooltip>
                                }
                            </div>
                            <div className="col-md-2 hidden-md-down">
                                <p>Totais:</p>
                            </div>
                            <div className={"col-4 col-md-2" + (schedules.length ? "" : "hidden") }>
                                <p className="smallText">Total de Dias:</p>
                                <p id="totalDays" className="result">{this.state.fetchData.data.totals[0].TotalDays}</p>
                            </div>
                            <div className={"col-4 col-md-2" + (schedules.length ? "" : "hidden") }>
                                <p className="smallText">Total de Horas:</p>
                                <p id="totalHours" className="result">{this.state.fetchData.data.totals[0].TotalHoursMinusPauses}</p>
                            </div>
                            <div className={"col-4 col-md-2" + (schedules.length ? "" : "hidden") }>
                                <p className="smallText">Total de Pausas:</p>
                                <p id="totalPauses" className="result">{this.state.fetchData.data.totals[0].TotalPauses}</p>
                            </div>
                            <div className="col-md-2 text-right hidden-md-down">
                                { (isAdmin || loginData.profile.Schedules.seeFuture) && 
                                    <Tooltip
                                        title={"Mês Seguinte"}
                                        enterDelay={200}>
                                        <span><button type="button" onClick={this.handleNextMonth} className="button simpleBtn actionButton mainColor"><i className='fa fa-chevron-right'></i></button></span>
                                    </Tooltip>
                                }
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-12 buttonsHolder">
                            <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                            {editable && <Button onClick={this.handleSave.bind(this)} className="float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                        </div>
                    </div>
                    {this.state.breakOpenModal && <BreakModalBox modalCallBack={this.breakCallBack} isActive={this.state.breakOpenModal} staffId={this.state.staffId} breakDate={this.state.breakDate} loginData={this.props.loginData} editable={(isAdmin || (loginData.profile.Schedules.handleBreaks && loginData.profile.Schedules.handleBreaks.permission === 1))} />}
                    {this.state.dayOffOpenModal && <DayOffModalBox modalCallBack={this.dayOffCallBack} isActive={this.state.dayOffOpenModal} dayOffId={this.state.dayOffId} staffId={this.state.staffId} dateStarted={this.state.dateStarted} dateEnded={this.state.dateEnded} loginData={this.props.loginData} editable={(isAdmin || (loginData.profile.Schedules.handleHolidays && loginData.profile.Schedules.handleHolidays.permission === 1))} />}
                    {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
                </div>
        );
    }
}

export default Schedules;
